import React, { useEffect, useState } from "react";
import { Divider } from "antd";
import FilterSection from "../../modules/Dashboards/Booking/FilterSection";
import BookingOverview from "../../modules/Dashboards/Booking/BookingOverview";
import ApplicationStatics from "../../modules/Dashboards/Booking/ApplicationStatics";
import DashboardLayout from "../../molecules/DashboardLayout";
import { getBookingsWidgetAccess } from "../../modules/Dashboards/Booking/BookingOverview/utili";

const BookingDashboard: React.FC = React.memo(() => {
  const [widgetAccess, setWidgetAccess]: any = useState();
  const [dashboardkey, setDashboardKey] = useState("bookings");

  return (
    <DashboardLayout>
      <div>
        <FilterSection
          setWidgetAccess={setWidgetAccess}
          setDashboardKey={setDashboardKey}
          dashboardkey={dashboardkey}
        />

        <Divider />

        <BookingOverview widgetAccess={widgetAccess?.result} />

        {getBookingsWidgetAccess(widgetAccess?.result, "applicationStatistics") && <ApplicationStatics />}
      </div>
    </DashboardLayout>
  );
});

export default BookingDashboard;
